var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showDropPlayerDialog)?_c('confirm-dialog',{attrs:{"visible":_vm.showDropPlayerDialog,"title":_vm.$t('common.drop-player'),"entity":_vm.player,"text":_vm.confirmDialogText,"confirmButtonClasses":"error","closeAction":_vm.closeConfirmDialog,"confirmAction":_vm.confirmedDialog}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }